import React, { useContext, useEffect, useMemo, useState } from 'react';
import { useParams } from 'react-router-dom';

import ItemBox from 'components/item/ItemBox';

import Back from 'components/shared/Back';
import Body from 'components/shared/Body';
import ErrorBox from 'components/shared/ErrorBox';
import Loading from 'components/shared/Loading';
import Navbar from 'components/shared/Navbar';
import RedirectTo from 'components/shared/RedirectTo';
import SignedIn from 'components/shared/SignedIn';
import ThemeColor from 'components/shared/ThemeColor';

import { ItemContext } from 'components/shared/context/ItemContextProvider';
import { ToastContext } from 'components/shared/context/ToastContextProvider';
import { UserContext } from 'components/shared/context/UserContextProvider';

import sansanTech from 'services/sansantech';

const ItemPage: React.FC = () => {
  const { itemId } = useParams();

  const [isLoading, setIsLoading] = useState(false);

  const isItemIdValid = useMemo(
    () => Number.isInteger(Number(itemId)) === true,
    [itemId]
  );

  const { userState } = useContext(UserContext);
  const { setItem } = useContext(ItemContext);
  const { toastDispatch } = useContext(ToastContext);

  useEffect(() => {
    if (userState.token && isItemIdValid && itemId !== undefined) {
      setIsLoading(true);
      sansanTech
        .getItem(userState.token, Number(itemId))
        .then((response) => {
          console.log(response);
          setIsLoading(false);
          setItem?.(response.data);
        })
        .catch((error) => {
          console.log(error);
          setIsLoading(false);
          toastDispatch?.({ type: 'ERROR', message: 'Could not get item' });
        });
    }
  }, [userState, isItemIdValid, itemId, setItem, toastDispatch]);

  return (
    <SignedIn>
      <RedirectTo redirectCondition={!isItemIdValid} redirectRoute="/404">
        <Loading isLoading={isLoading}>
          <ThemeColor color="white">
            <Navbar />
            <Body>
              {userState.company ? (
                <>
                  <Back linkBackTo="/" />
                  <ItemBox />
                </>
              ) : (
                <ErrorBox errorMessage="Your account is not connected to a company yet" />
              )}
            </Body>
          </ThemeColor>
        </Loading>
      </RedirectTo>
    </SignedIn>
  );
};

export default ItemPage;
